import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

const Layout = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: minmax(0, 1fr);
    grid-template-columns: minmax(0, 1fr);
    margin-bottom: ${({ noMarginBottom, theme }) =>
        noMarginBottom ? `0` : theme.layout.sectionMargin};
    align-items: ${({ stickySidebar }) =>
        stickySidebar ? "flex-start" : "stretch"};

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
        -ms-grid-columns: ${({ theme }) =>
            `minmax(0, 2fr) ${theme.layout.gutter} minmax(0, 1fr)`};
        grid-template-columns: ${({ theme }) =>
            `minmax(0, 2fr) ${theme.layout.gutter} minmax(0, 1fr)`};
    }
`;

const Main = styled.div`
    @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
        -ms-grid-column: ${({ hideSidebar }) => (hideSidebar ? `1 / 4` : `1`)};
        grid-column: ${({ hideSidebar }) => (hideSidebar ? `1 / 4` : `1`)};
    }
`;

const Sidebar = styled.div`
    display: ${({ hideSidebarOnMobile }) =>
        hideSidebarOnMobile ? `none` : `block`};

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
        display: block;
        -ms-grid-column: 3;
        grid-column: 3;
        top: ${({ stickySidebar, theme }) =>
            stickySidebar ? theme.layout.paragraphSpacing : "0"};
        position: ${({ stickySidebar }) =>
            stickySidebar ? "sticky" : "static"};
    }
`;

const TwoColumnLayout = ({
    main,
    noMarginBottom = false,
    sidebar = null,
    stickySidebar = false,
    hideSidebar = false,
    hideSidebarOnMobile = false,
}) => (
    <Layout {...{ noMarginBottom, stickySidebar }}>
        <Main {...{ hideSidebar }}>{main}</Main>
        {!hideSidebar && sidebar ? (
            <Sidebar {...{ hideSidebarOnMobile, stickySidebar }}>
                {sidebar}
            </Sidebar>
        ) : null}
    </Layout>
);

TwoColumnLayout.propTypes = {
    main: PropTypes.node.isRequired,
    noMarginBottom: PropTypes.bool,
    sidebar: PropTypes.node,
    stickySidebar: PropTypes.bool,
    hideSidebar: PropTypes.bool,
    hideSidebarOnMobile: PropTypes.bool,
};

export default TwoColumnLayout;
